export { consoleDarkTheme, consoleDarkerTheme, consoleLightTheme } from './themes/console/index.js';
